import { type ExperimentalVCDevToolsOptions } from '../../types';

export const initDevTools = () => {
	window.VCDevTools = (opts?: ExperimentalVCDevToolsOptions) =>
		import(/* webpackChunkName: "vc-dev-tools" */ './dev-tools').then(({ startVCDevTools }) =>
			startVCDevTools?.(opts),
		);
};
